// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgStar24 = forwardRef(({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
	let ariaLabelledBy = titleid ? titleid : "";
	ariaLabelledBy += desc && descid ? ` ${descid}` : "";
	ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
	props["aria-labelledby"] = ariaLabelledBy;
	return (
		<Svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
			title={title}
			titleid={titleid}
			desc={desc}
			descid={descid}
			aria-labelledby={ariaLabelledBy}
			aria-hidden={!ariaLabelledBy}
			ref={ref}
			{...props}
		>
			{!!title && <title id={titleId}>{title}</title>}
			{!!desc && <desc id={descId}>{desc}</desc>}
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.4485 2.90934C12.3998 2.81062 12.3199 2.73073 12.2212 2.68205C11.9735 2.55991 11.6737 2.66167 11.5516 2.90934L8.91561 8.25463L3.01737 9.10983C2.90844 9.12563 2.80776 9.17692 2.73096 9.25576C2.53827 9.45356 2.54242 9.77012 2.74022 9.96281L7.00932 14.1216L6.00001 19.9954C5.98137 20.1039 5.99904 20.2155 6.05029 20.3129C6.17887 20.5573 6.48121 20.6512 6.72559 20.5226L12 17.7476L17.2745 20.5226C17.3719 20.5738 17.4835 20.5915 17.592 20.5729C17.8641 20.5261 18.0469 20.2676 18.0001 19.9954L16.9908 14.1216L21.2599 9.96281C21.3387 9.886 21.39 9.78533 21.4058 9.6764C21.4454 9.40312 21.256 9.14946 20.9827 9.10983L15.0845 8.25463L12.4485 2.90934ZM10.2609 8.91807L12 5.39L13.7392 8.91807L13.8107 9.04681C14.0429 9.4202 14.4292 9.67531 14.8692 9.73911L18.76 10.303L15.9441 13.0471L15.8333 13.1674C15.5574 13.5021 15.4381 13.9428 15.5124 14.3756L16.178 18.251L12.6985 16.4201L12.5498 16.3519C12.1462 16.1929 11.6903 16.2156 11.3016 16.4201L7.82105 18.251L8.48766 14.3756L8.50654 14.2132C8.53307 13.7802 8.37056 13.3536 8.05601 13.0471L5.23905 10.303L9.13085 9.73911C9.61976 9.66822 10.0424 9.36114 10.2609 8.91807Z"
			/>
		</Svg>
	);
});
SvgStar24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgStar24;
